(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["payment-icons"] && !Shopify.designMode) return;
  try {
    (function () {

    /* ── 1. 找 Buy-it-now 按钮（优先级从高到低） ── */
    function findBuyItNowBtn() {
      const selectors = [
        '.shopify-payment-button__button--unbranded',
        '.shopify-payment-button__button:not([aria-hidden="true"])',
        '[name="checkout"]',
        'button[id*="buy-it-now"]',
        '.product-form__submit[name="checkout"]',
        '[data-testid="Checkout-button"]',
      ];
      for (const sel of selectors) {
        const btn = document.querySelector(sel);
        if (btn && !btn.disabled) return btn;
      }
      return null;
    }

    /* ── 2. 找当前产品表单 ── */
    function findProductForm() {
      const selectors = [
        'form[action="/cart/add"]',
        'form[data-product-form]',
        '.product-form form',
        '#product-form',
      ];
      for (const sel of selectors) {
        const form = document.querySelector(sel);
        if (form) return form;
      }
      return null;
    }

    /* ── 3. 从表单中提取 variant id ── */
    function getVariantId(form) {
      const idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) return idInput.value;

      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('variant')) return urlParams.get('variant');

      return null;
    }

    /* ── 4. 用 Ajax API 加入购物车，返回 Promise ── */
    function addToCartAjax(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 }),
      }).then(res => {
        if (!res.ok) return res.json().then(e => Promise.reject(e));
        return res.json();
      });
    }

    /* ── 5. 检查购物车是否为空，返回 Promise<boolean> ── */
    function isCartEmpty() {
      return fetch('/cart.js')
        .then(r => r.json())
        .then(cart => cart.item_count === 0);
    }

    /* ── 6. 主流程 ── */
    function triggerBuyItNow() {
      const btn = findBuyItNowBtn();

      if (btn) {
        btn.click();
        return;
      }

      const form = findProductForm();
      if (!form) {
        window.location.href = '/checkout';
        return;
      }

      const variantId = getVariantId(form);
      if (!variantId) {
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.click();
        return;
      }

      const qtyInput = form.querySelector('[name="quantity"]');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      isCartEmpty().then(empty => {
        if (!empty) {
          window.location.href = '/checkout';
          return;
        }

        addToCartAjax(variantId, quantity)
          .then(() => { window.location.href = '/checkout'; })
          .catch(err => {
            console.warn('[payment-icons] add-to-cart failed', err);
            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn) submitBtn.click();
            else window.location.href = '/checkout';
          });
      });
    }

    /* ── 7. 在相邻图标之间插入 spacer，绑定点击事件 ── */
    function initPaymentIcons() {
      const lists = document.querySelectorAll('[data-payment-icons-list]');
      lists.forEach(list => {
        const items = Array.from(list.querySelectorAll('.payment-icons__item'));

        /* 在每两个相邻图标之间插入一个 spacer li */
        items.forEach((item, i) => {
          if (i < items.length - 1) {
            const spacer = document.createElement('li');
            spacer.className = 'payment-icons__spacer';
            item.after(spacer);
          }
        });

        list.onclick = triggerBuyItNow;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPaymentIcons);
    } else {
      initPaymentIcons();
    }

  })();
  } catch(e) { console.error(e); }
})();

})();
